import { Type } from '@angular/core';
import { ModelAttribute } from '../../decorators/ModelAttribute.decorator';

export class BaseModel {
  @ModelAttribute({
    updatable: false
  })
  Id?: number|string;

  // @ModelAttribute({
  //   updatable: false
  // })
  // uuid?: string;

  @ModelAttribute({
    updatable: false
  })
  version?: number;

  public get isNew(): boolean {
    if (this.Id) {
      return this.Id === undefined || this.Id === null || this.Id <= 0 || this.Id === '';
    }

    // if (this.uuid) {
    //   return this.uuid === undefined || this.uuid === null || this.uuid.trim() === '';
    // }

    return true;
  }

  /**
   * @description
   * Devuelve el nombre del campo de base de datos definido en el modelo de la entidad
   * @param type Tipo de la propiedad
   * @param propertyKey Nombre de la propiedad
   */
  static getFieldName<T>(type: Type<T>, propertyKey: string) {
    return this.getMetaDataFromGenericType(new type(), propertyKey, 'attribute:fieldName');
  }

  /**
   * @description
   * Devuelve el tipo del campo de base de datos definido en el modelo de la entidad
   * @param type Tipo de la propiedad
   * @param propertyKey Nombre de la propiedad
   */
  static getfieldType<T>(type: Type<T>, propertyKey: string) {
    return this.getMetaDataFromGenericType(new type(), propertyKey, 'attribute:fieldType');
  }

  /**
   * @description
   * Devuelve si la propiedad del modelo es actualizable
   * @param type Tipo de la propiedad
   * @param propertyKey Nombre de la propiedad
   */
  static isUpdatable<T>(type: Type<T>, propertyKey: string): boolean {
    const updatable = this.getMetaDataFromGenericType(new type(), propertyKey, 'attribute:updatable');

    return updatable === undefined || updatable === null ? false : updatable;
  }

  /**
   * @description
   * Obtiene los metadatos para el tipo génerico actual.
   * @param instance Instancia del objeto del que se quiere obtener los metadatos
   * @param propertyKey Nombre de la propiedad
   * @param metadataKey Nombre del metadato a obtener.
   */
  private static getMetaDataFromGenericType<T>(instance: T, propertyKey: string, metadataKey: string) {
     if (!!Reflect.getMetadata(metadataKey, instance, propertyKey)) {
        return Reflect.getMetadata(metadataKey, instance, propertyKey);
     }
     return null;
  }

}
